import React, {useState} from "react";
import { Button, Modal} from 'antd';
import List from "../wrappers/List";
import { ReadOutlined } from '@ant-design/icons';

export default function EventViewMore(props){

    const {data, type="more", cc_event = false} = props; 

    
    const [modalVisible, setModalVisible] = useState(false); 
    const close = () =>{ setModalVisible(false)}

    const displayButton = () =>{

        if(cc_event){
            return (<div onClick={() => setModalVisible(true)} >{props.children}</div>);
        }

        switch(type){
            case "image":
                return(<div style={{"display" : "flex", "cursor" : "pointer", "flexDirection" : "row"}} onClick={() => setModalVisible(true)}  type="primary" >{props.children}</div>); 
            case "book":
                return(<Button onClick={() => setModalVisible(true)}  type="primary" >Buy Books</Button>); 
            case "ticket":
                return(<Button onClick={() => setModalVisible(true)} type="secondary" >Buy Tickets</Button>); 
            default:
                return(<Button onClick={() =>setModalVisible(true)} style={{"width" : "90%", "marginTop" : "20px"}} type="text" icon={<ReadOutlined aria-hidden />} block >More</Button>); 
        }
    }
   


    return(<>
        {displayButton()}
        
    <Modal wrapClassName="siteModal" width={(data.length>1) ? "90%" : 512} title={"Books"} open={modalVisible} onCancel={close} destroyOnClose closable={true} footer={null}>
            <List data={data} />
        </Modal>
        </>
    ); 

}